export default __webpack_public_path__ + "1password-logo.6ce9b72a.png";